import api from '@/api'

export default {
    getResourceAvailable(param: reserve.ResourceAvailableRequest): Promise<reserve.ResourceAvailibility> {
        return api.post<reserve.ResourceAvailibility>({
            url: '/Portal/Reservation/api/resourceAvailable',
            data: param
        })
    },

    getAvailableRooms(param: reserve.AvailableResourceRequest): Promise<reserve.ResourceItemBase[]> {
        return api.post<reserve.ResourceItemBase[]>({
            url: '/Portal/Reservation/api/availableResources',
            data: param
        })
    },

    getResource(itemStore: string, address: string): Promise<reserve.ResourceItemBase> {
        return api.get<reserve.ResourceItemBase>({
            url: '/Portal/Reservation/api/resource',
            params: {
                itemStore: itemStore,
                address: address
            }
        })
    },

    getResources(comCode: string, itemStore: string): Promise<reserve.ResourceItemBase[]> {
        return api.get<reserve.ResourceItemBase[]>({
            url: '/Portal/Reservation/api/resources',
            params: {
                comCode: comCode,
                itemStore: itemStore
            }
        })
    },

    getResourceGroups(comCode: string, itemStore: string): Promise<reserve.ResourceItemBase[]> {
        return api.get<reserve.ResourceItemBase[]>({
            url: '/Portal/Reservation/api/resourceGroups',
            params: {
                comCode: comCode,
                itemStore: itemStore
            }
        })
    },

    getResourceInformation(uniqueId: string): Promise<reserve.ResourceInformation> {
        return api.get<reserve.ResourceInformation>({
            url: '/Portal/Reservation/api/resourceInformation',
            params: {
                uniqueId: uniqueId
            }
        })
    },

    toggleResourceBookmark(toggle: boolean, uniqueId: string): Promise<boolean> {
        return api.get<boolean>({
            url: '/Portal/Reservation/api/toggleBookmark',
            params: {
                toggle: toggle,
                uniqueId: uniqueId
            }
        })
    },

    getBookmarkResources(): Promise<reserve.ResourceItemBase> {
        return api.get<reserve.ResourceItemBase>({
            url: '/Portal/Reservation/api/bookmarks'
        })
    }
}